// 普通搜索 就一个条件
export const COMMON_SEARCH_CONDITION = 'COMMON_SEARCH_CONDITION';

// 高级搜索条件
export const ADVANCE_SEARCH_CONDITION = 'ADVANCE_SEARCH_CONDITIONS';

// 搜索返回的信息
export const SEARCH_ANSWER = 'SEARCH_ANSWER';




// WEBPACK FOOTER //
// ./src/config/localStoreKey.js